/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateHeroBannerDto } from '../../models/create-hero-banner-dto';
import { HeroBannerDto } from '../../models/hero-banner-dto';

export interface HeroBannerControllerCreateV1$Params {
      body: CreateHeroBannerDto
}

export function heroBannerControllerCreateV1(http: HttpClient, rootUrl: string, params: HeroBannerControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HeroBannerDto>> {
  const rb = new RequestBuilder(rootUrl, heroBannerControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeroBannerDto>;
    })
  );
}

heroBannerControllerCreateV1.PATH = '/api/v1/hero-banner';
